import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SavingsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        stroke="#000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="0.5"
        d="M41.39 29.23s7.14 4.74 7.62-1.9-8.08-3.15-3.63 7.19"
      ></path>
      <path
        fill="#fff"
        className={styles.defaultStrokeColor}
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M41.39 31.63c0-7.24-8.25-13.12-18.42-13.12-3.29 0-6.39.62-9.06 1.7-.1.04-.22.03-.32-.02-3.24-1.89-5.51-2.54-6.89-2.74-.72-.11-1.24.66-.88 1.29l2.55 4.51c.08.15.05.33-.07.45-1.98 1.85-3.28 4.08-3.65 6.52-.02.14-.11.25-.24.29l-3.16 1.03c-.17.06-.28.23-.25.4l.48 3.27c.02.12.1.23.21.28l4.89 2.21c.05.02.1.06.14.11 1.54 2.05 3.81 3.77 6.58 4.98.13.06.22.19.22.33v4.94c0 .2.16.37.37.37h5.27c.17 0 .31-.11.35-.27l.89-3.25c.05-.17.21-.28.38-.27a25.117 25.117 0 009.09-.85c.24-.07.47.1.47.35v3.93c0 .2.16.37.37.37h4.45c.14 0 .27-.08.33-.22l1.69-3.7s.03-.1.03-.15v-4.25c0-.1.05-.2.12-.27 2.54-2.25 4.06-5.11 4.06-8.22z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="0.5"
        d="M10.62 31.12a1.92 1.92 0 100-3.84 1.92 1.92 0 000 3.84z"
      ></path>
      <path
        fill="#E81C30"
        className={styles.accentColor}
        fillRule="evenodd"
        d="M22.65 22.16c1.29 0 2.69.13 4.15.38 1.77.31 3.4.78 4.79 1.34a8.26 8.26 0 005.08-7.62c0-4.56-3.7-8.26-8.26-8.26s-8.26 3.7-8.26 8.26c0 2.31.95 4.4 2.49 5.9z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="0.5"
        d="M20.86 22.25s6.8-.95 13.6 3.13"
      ></path>
    </Icon>
  )
}
